// Frontend mirror of derive_archetype + derive_score in /app/backend/server.py.
// Used by the admin SnapshotsGrid so we can render archetype tiles without
// a per-row API roundtrip. The drawer still hits /api/admin/responses/:id
// for the canonical server-derived payload.

const ARCHETYPES = {
    EXPLORER: {
        key: "EXPLORER",
        emoji: "🧭",
        name: "EXPLORER",
        color: "#0D9488",
        line:
            "You know you want something meaningful. You just haven't found the word for it yet.",
    },
    BUILDER: {
        key: "BUILDER",
        emoji: "🔨",
        name: "BUILDER",
        color: "#3B82F6",
        line:
            "You have more capability than you let yourself believe. That is the whole problem.",
    },
    CREATOR: {
        key: "CREATOR",
        emoji: "✦",
        name: "CREATOR",
        color: "#8B5CF6",
        line:
            "You want to make something real. Something that didn't exist before you showed up.",
    },
    GROWER: {
        key: "GROWER",
        emoji: "↑",
        name: "GROWER",
        color: "#10B981",
        line:
            "You know what you're capable of. The gap is between you and the people making the decision.",
    },
    SWITCHER: {
        key: "SWITCHER",
        emoji: "⇄",
        name: "SWITCHER",
        color: "#F97316",
        line:
            "You've built real skills in the wrong direction. That's fixable. Faster than you think.",
    },
    REENTRANT: {
        key: "REENTRANT",
        emoji: "◎",
        name: "REENTRANT",
        color: "#F59E0B",
        line:
            "The world interrupted your career. That's not a setback. It's a chapter.",
    },
    BROWSER: {
        key: "BROWSER",
        emoji: "◐",
        name: "BROWSER",
        color: "#0D9488",
        line:
            "You're questioning whether the career you built is the career you actually want. Smart question.",
    },
    LEADER: {
        key: "LEADER",
        emoji: "◈",
        name: "LEADER",
        color: "#14B8A6",
        line: "You think about careers at scale. So do we.",
    },
};

function deriveArchetype(persona, pain) {
    if (persona === "student") {
        if (pain === "direction") return ARCHETYPES.EXPLORER;
        if (pain === "confidence") return ARCHETYPES.BUILDER;
        return ARCHETYPES.CREATOR;
    }
    if (persona === "professional") {
        if (pain === "stuck") return ARCHETYPES.GROWER;
        if (pain === "direction") return ARCHETYPES.SWITCHER;
        if (pain === "external") return ARCHETYPES.REENTRANT;
        return ARCHETYPES.BROWSER;
    }
    return ARCHETYPES.LEADER;
}

// Quick approximate score based on persona+pain. The actual score is
// computed server-side from full inputs (klareet_appeal, gap, waitlist) and
// shown in the drawer; the tile-grid only uses this for a friendly preview
// number. Falls back gracefully if a row is missing fields.
function approximateScore(r) {
    let s = 50;
    if (r.klareet_appeal != null) s += (Number(r.klareet_appeal) - 5) * 3;
    if (r.pain === "direction") s += 8;
    if (r.gap === "generic") s += 5;
    if (r.gap === "not_honest") s += 7;
    return Math.max(38, Math.min(94, Math.round(s)));
}

export function ARCHETYPE_FOR(persona, pain) {
    return deriveArchetype(persona, pain);
}

export function ARCHETYPE_TILE(r) {
    const a = deriveArchetype(r.persona, r.pain);
    return { ...a, score: approximateScore(r) };
}
